export enum CarPriceRange {
  OneDay = 1,
  ThreeDays = 3,
  EightDays = 8,
  TwentyFiveDays = 25,
  LongTerm = 99,
}

export enum FuelType {
  Petrol = "petrol",
  Diesel = "diesel",
  Electric = "electric",
}

export enum Transmission {
  Manual = "manual",
  Automatic = "automatic",
}

export interface Car {
  id: string;
  make: string;
  model: string;
  logo: string;
  price: Record<CarPriceRange, number>;
  imagesAmount: number;
  fuelType: FuelType;
  transmission: Transmission;
  seats: number;
  engine: string;
  deposit: number;
  dailyKmIncluded: number;
  additionalKmPrice: number;
  productionYear: number;
  props: Prop[];
  isCabrio?: boolean;
}

export enum Prop {
  AirConditioning = "air-conditioning",
  AndroidAuto = "android-auto",
  AppleCarPlay = "apple-car-play",
  BackViewCamera = "back-view-camera",
  Bluetooth = "bluetooth",
  Camera360 = "camera-360",
  CruiseControl = "cruise-control",
  ForwardCollisionWarning = "forward-collision-warning",
  FrontParkingSensors = "front-parking-sensors",
  HeatedSeats = "heated-seats",
  KeylessEntry = "keyless-entry",
  LeatherInterior = "leather-interior",
  Navigation = "navigation",
  RearParkingSensors = "rear-parking-sensors",
  StartStopButton = "start-stop-button",
  USBPort = "usb-port",
  WirelessCharging = "wireless-charging",
}

// use ISO 639-1 language codes
export enum Language {
  English = "en",
  Spanish = "es",
  Russian = "ru",
  Ukrainian = "uk",
}
